import { RadioGroup as ChakraRadioGroup, RadioGroupProps, useMultiStyleConfig } from '@chakra-ui/react';

export type { RadioGroupProps };

const FilterSwitchGroup = (props: RadioGroupProps) => {
  const { container } = useMultiStyleConfig('FilterSwitch');

  return <ChakraRadioGroup sx={container} {...props} />;
};

export default FilterSwitchGroup;
